import { render, staticRenderFns } from "./ReportPostModal.vue?vue&type=template&id=66cc34e2&scoped=true&"
import script from "./ReportPostModal.vue?vue&type=script&lang=js&"
export * from "./ReportPostModal.vue?vue&type=script&lang=js&"
import style0 from "./ReportPostModal.vue?vue&type=style&index=0&id=66cc34e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cc34e2",
  null
  
)

export default component.exports